import sotran from '../config/sotran';

const rbacRules = {
  CLIENTE: {},
  SOTRAN: {
    dynamic: {
      'cadastro-usuario:show': ({ cliente_cnpj_resumido }) => {
        if (!cliente_cnpj_resumido) return false;
        return cliente_cnpj_resumido === sotran.cnpj_resumido;
      },
    },
  },
};

export default rbacRules;
